import { render, staticRenderFns } from "./ProductSegment.vue?vue&type=template&id=7bc9aa2a&scoped=true"
import script from "./ProductSegment.vue?vue&type=script&lang=ts"
export * from "./ProductSegment.vue?vue&type=script&lang=ts"
import style0 from "./ProductSegment.vue?vue&type=style&index=0&id=7bc9aa2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc9aa2a",
  null
  
)

export default component.exports